import {caCode, ukCode, usCodes} from 'Utility/commons/countries/codes';
import type {ValidationSchema} from 'Utility/validations/types';
import {
  tinMask as getTinMask,
  tinPlaceholder as getTinPlaceholder,
  tinLabel as getTinLabel,
} from 'Utility/commons/tinMask';
import {getNationalIdLabel} from 'Utility/commons/countries/nationalIdLabels';

export const supportedTinCountry = Object.freeze([...usCodes, caCode, ukCode]);

export const validSupportedTinCountry = (countryCode: string): boolean => {
  return supportedTinCountry.includes(countryCode);
};

export const getValidTin = (entity: any) => {
  return entity &&
    (validSupportedTinCountry(entity.countryCode) ||
      entity.countryCode === undefined)
    ? entity?.tin
    : '';
};

export const addTinToSchema = (
  validationSchema: ValidationSchema,
  countryCode: string,
  id = ''
): ValidationSchema => {
  const countryIntl = !validSupportedTinCountry(countryCode);
  return {
    ...validationSchema,
    [`tin${id}`]: `${
      countryIntl ? '' : 'required|'
    }tin:${countryCode}|label:[TIN]|message:[Valid TIN required]`,
  };
};

export const removeTinFromSchema = (
  validationSchema: ValidationSchema
): ValidationSchema => {
  const {tin: _, ...rest} = validationSchema;
  return rest;
};

export const getTinInputData = (countryCode: string) => {
  if (supportedTinCountry.includes(countryCode)) {
    const nationalIdCountryCode = countryCode === ukCode ? ukCode : undefined;

    return {
      mask: getTinMask(countryCode),
      tinPlaceholder: getTinPlaceholder(countryCode),
      tinLabel: getTinLabel(countryCode),
      collectingTin: validSupportedTinCountry(countryCode),
      nationalId: getNationalIdLabel(nationalIdCountryCode),
    };
  } else {
    return {
      mask: '',
      tinPlaceholder: '',
      tinLabel: '',
      collectingTin: false,
      nationalId: '',
    };
  }
};
